










































import { computed } from "@vue/composition-api";
import cardLogo from "@/assets/cardBanner/card-logo.svg";
import vuexStore from "@/store";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const currentTheme = computed(() => vuexStore.state.theme.currentTheme);
  const user = computed(() => vuexStore.getters.user);
  const asAdmin = computed(() => vuexStore.getters.asAdmin);
  const link = computed(() => {
    if (process.env.NODE_ENV !== "production") {
      return "https://lemonadcard.com/";
    }
    const utmSource = asAdmin.value ? "admin" : `${user.value?.login ?? ""}+${user.value?.intId ?? ""}`;
    return `https://lemonadcard.com/?utm_source=${utmSource}&utm_medium=banner&utm_term=2.5%25+%D1%81+lm`;
  });
  return {
    cardLogo,
    currentTheme,
    link
  };
};
export default __sfc_main;
